import { Component, Input, ViewEncapsulation } from '@angular/core';
import { ClientModel } from '../../../shared/models/client.model';
import { AddressModel } from '../../../shared/models/address.model';
import { OauthService } from '../../../shared/services/oauth.service';
import { CommonHttpService } from '../../../shared/services/http.service';
import { Response } from '@angular/http';

@Component({
    selector: 'account-profile-addresses',
    templateUrl: './account.profile.addresses.component.html',
    styleUrls: [],
    encapsulation: ViewEncapsulation.None
})
export class AccountProfileAddressesComponent {
    @Input('client') client: ClientModel;

    public addresses: Array<AddressModel> = [];

    constructor(
        protected http: CommonHttpService,
        protected oauthService: OauthService
    ) {
        this.oauthService.loadedAuthenticatedUser$.subscribe((client: ClientModel) => {
            this.client = client;
            this.indexAddresses();
        });
    }

    public pushNewAddress() {
        this.addresses.unshift(new AddressModel());
    }

    public shiftNewAddress(adding) {
        if (adding) {
            this.addresses.shift();
        }
    }

    public indexAddresses() {
        this.http
            .useAuth()
            .get(`/account/clients/${this.client.id}/addresses?_sort=-updated_at&_limit=5`)
            .subscribe((response: Response) => {
                this.addresses = response.json().data;
            });
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src4078178155/src/src/app/account/profile/addresses/account.profile.addresses.component.ts